import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { SVGIcon } from '../SVGIcon';
import { StyledOpenButtonWrapper, StyledButtonText, StyledSVGIcon, StyledSpinner } from './TextLink.styles';
import { ReactChildrenPropType } from '../../../lib/commonPropTypes';

function TextLink(props) {
  const {
    children,
    color,
    icon,
    iconPlacement,
    onClick,
    hasBorder,
    noMargins,
    className,
    loading,
    disabled,
    showIconOnHover
  } = props;

  const [showIcon, setShowIcon] = useState(!showIconOnHover);

  const hoverHandler = () => {
    if (showIconOnHover) {
      setShowIcon(showIcon);
    }
  };

  const resolvedIcon = loading ? <StyledSpinner spinnerColor={color} size={16} thickness={8} /> : icon;

  return (
    <StyledOpenButtonWrapper
      type="button"
      className={`toggle-button ${className}`}
      hasBorder={hasBorder}
      onClick={onClick}
      onMouseEnter={hoverHandler}
      onMouseLeave={hoverHandler}
      noMargins={noMargins}
      disabled={disabled}
    >
      {iconPlacement === 'before' && showIcon && <StyledSVGIcon>{resolvedIcon}</StyledSVGIcon>}
      <StyledButtonText iconPlacement={iconPlacement} className="button-text" color={color} tagName="span">
        {children}
      </StyledButtonText>
      {iconPlacement === 'after' && showIcon && <StyledSVGIcon>{resolvedIcon}</StyledSVGIcon>}
    </StyledOpenButtonWrapper>
  );
}

TextLink.propTypes = {
  /** Text to display in the link */
  children: ReactChildrenPropType,
  /** Text color */
  color: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'quaternary', 'error']),
  /** SVGIcon component to override the default */
  icon: PropTypes.node,
  /** Places icon either before or after text */
  iconPlacement: PropTypes.oneOf(['before', 'after']),
  /** function onClick */
  onClick: PropTypes.func,
  /** adds border above */
  hasBorder: PropTypes.bool,
  /** Hides the icon and only shows on hover */
  showIconOnHover: PropTypes.bool,
  /** Removes default margins */
  noMargins: PropTypes.bool,
  /** Classname for styling purposes */
  className: PropTypes.string,
  /** Boolean to toggle loading state */
  loading: PropTypes.bool,
  /** Boolean to toggle disabled state */
  disabled: PropTypes.bool
};

TextLink.defaultProps = {
  children: 'Open',
  color: 'quaternary',
  icon: <SVGIcon selectedIcon="openPanel" />,
  iconPlacement: 'before',
  onClick: () => {},
  hasBorder: false,
  showIconOnHover: false,
  noMargins: false,
  className: '',
  loading: false,
  disabled: false
};

export default TextLink;
